import Slider from "./slider"
export default Slider



/** WEBPACK FOOTER **
 ** ./es2015/controls/slider/index.js
 **/